module.exports = __webpack_public_path__ + "static/image1-vr-stranded-bc76589a2de8457da2a1f245edb136ad.png";